import { useLayoutEffect } from 'react';

function isInViewport(el: HTMLElement): boolean {
  const rect = el.getBoundingClientRect();
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  return rect.bottom >= 0 && rect.right >= 0 && rect.top <= viewportHeight && rect.left <= viewportWidth;
}

/**
 * Calls focus on the element if it is in the viewport when ref is set
 *
 * It does not do any observation of the viewport so it
 * will not call focus if the element is scrolled out of the viewport.
 */
export function useFocusIfInViewport(
  ref: React.RefObject<HTMLElement | null>,
  {
    disabled = false,
  }: {
    /** Will not call focus if disabled is true */
    disabled?: boolean;
  } = {}
): void {
  useLayoutEffect(() => {
    const element = ref.current;
    if (element && !disabled && isInViewport(element)) element.focus();
  }, [ref.current, disabled]);
}
